export default __webpack_public_path__ + "static/media/Q-A_Numbers.9712d2c6.svg";